import {
  TeamsTeamAriResourceOwner,
  TeamsTeamAriResourceType
} from "./chunk-MUICIWTK.mjs";
import {
  RegisteredAri
} from "./chunk-AB4PPISI.mjs";
import {
  AriParser
} from "./chunk-S7RIZVFI.mjs";

// src/teams/team/manifest.ts
var teamsTeamAriStaticOpts = {
  qualifier: "ari",
  platformQualifier: "cloud",
  cloudId: new RegExp("^$"),
  // eslint-disable-line no-useless-escape
  resourceOwner: TeamsTeamAriResourceOwner,
  resourceType: TeamsTeamAriResourceType,
  resourceIdSlug: "{teamId}",
  resourceIdSegmentFormats: {
    teamId: /[a-zA-Z0-9.\-_~]+/
    // eslint-disable-line no-useless-escape
  }
};

// src/teams/team/index.ts
var TeamsTeamAri = class _TeamsTeamAri extends RegisteredAri {
  constructor(opts) {
    super(opts);
    this._teamId = opts.resourceIdSegmentValues.teamId;
  }
  get teamId() {
    return this._teamId;
  }
  static create(opts) {
    let derivedOpts = {
      qualifier: teamsTeamAriStaticOpts.qualifier,
      platformQualifier: teamsTeamAriStaticOpts.platformQualifier,
      cloudId: void 0,
      resourceOwner: teamsTeamAriStaticOpts.resourceOwner,
      resourceType: teamsTeamAriStaticOpts.resourceType,
      resourceId: `${opts.teamId}`,
      resourceIdSegmentValues: {
        teamId: opts.teamId
      }
    }, ariOpts = AriParser.fromOpts(derivedOpts, teamsTeamAriStaticOpts);
    return new _TeamsTeamAri(ariOpts);
  }
  static parse(maybeAri) {
    let opts = AriParser.fromString(maybeAri, teamsTeamAriStaticOpts);
    return new _TeamsTeamAri(opts);
  }
  getVariables() {
    return {
      teamId: this.teamId
    };
  }
};

export {
  TeamsTeamAri
};
